import { styled } from "@styles";

export const Form = styled.form``;

export const Status = styled.div`
  display: block;
  margin: 18px;
`;
